export const ngonThemesContext = 'ngonTheme';

export enum ThemeCollectionTypeName {
  Store = 'STORE',
  Product = 'PRODUCT',
}
